import { render, staticRenderFns } from "./laiyuan.vue?vue&type=template&id=dbece8a4&scoped=true&"
import script from "./laiyuan.vue?vue&type=script&lang=js&"
export * from "./laiyuan.vue?vue&type=script&lang=js&"
import style0 from "./laiyuan.vue?vue&type=style&index=0&id=dbece8a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbece8a4",
  null
  
)

export default component.exports